import { initializeMarketingMeasurement } from './MarketingMeasurement';

export const PRIVACY_CHOICE_STORAGE_KEY = 'ademero_privacy_choice_v1';
export const PRIVACY_CHOICE_EVENT = 'ademero-privacy-choice';
export const PRIVACY_POLICY_URL = 'https://www.ademero.com/privacy';
export const SALESIQ_WIDGET_CODE = 'siq0c28e03a39bb4e09f77fe92030c3ac493dcfbd280bc944638cef87389c1dd725';

const TRACKING_COOKIE_PREFIXES = ['_ga', '_gid', '_gcl', '_gat', '_fbp'];

const getDefaultStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null;
  } catch (err) {
    return null;
  }
};

export const readPrivacyChoice = (storage = getDefaultStorage()) => {
  if (!storage) return null;
  try {
    const value = storage.getItem(PRIVACY_CHOICE_STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch (err) {
    return null;
  }
};

const notify = choice => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PRIVACY_CHOICE_EVENT, { detail: { choice } }));
};

const clearTrackingCookies = () => {
  if (typeof document === 'undefined') return;
  const host = window.location.hostname;
  const domains = ['', host, `.${host}`, `.${host.split('.').slice(-2).join('.')}`];
  document.cookie.split(';').forEach(entry => {
    const name = entry.split('=')[0].trim();
    if (!TRACKING_COOKIE_PREFIXES.some(prefix => name.startsWith(prefix))) return;
    domains.forEach(domain => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain ? `; domain=${domain}` : ''}`;
    });
  });
};

// Nothing third-party (tags or chat) may load until the visitor accepts.
export const startConsentedServices = (storage = getDefaultStorage()) => {
  if (readPrivacyChoice(storage) !== 'granted') return false;
  initializeMarketingMeasurement();
  loadSalesIQ();
  return true;
};

export const setPrivacyChoice = (choice, storage = getDefaultStorage()) => {
  const previous = readPrivacyChoice(storage);
  try {
    if (storage) storage.setItem(PRIVACY_CHOICE_STORAGE_KEY, choice);
  } catch (err) {
    // A failed write only means the banner shows again on the next visit.
  }
  notify(choice);
  if (choice === 'granted') {
    startConsentedServices(storage);
  } else if (previous === 'granted') {
    // Tags already running on this page cannot be unloaded; drop their cookies and start clean.
    clearTrackingCookies();
    window.location.reload();
  }
};

export const resetPrivacyChoice = (storage = getDefaultStorage()) => {
  try {
    if (storage) storage.removeItem(PRIVACY_CHOICE_STORAGE_KEY);
  } catch (err) {
    // The banner is shown again regardless.
  }
  notify(null);
};

const openSalesIQWindow = () => {
  const salesiq = window.$zoho && window.$zoho.salesiq;
  if (salesiq && salesiq.floatwindow && typeof salesiq.floatwindow.visible === 'function') {
    salesiq.floatwindow.visible('show');
    return true;
  }
  return false;
};

// Loads only the Zoho SalesIQ script: after Accept, or when the visitor starts a chat.
export const loadSalesIQ = ({ open = false } = {}) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (document.getElementById('zsiqscript')) {
    if (open && !openSalesIQWindow()) window.__ademeroOpenChatOnReady = true;
    return;
  }
  window.__ademeroOpenChatOnReady = open;
  window.$zoho = window.$zoho || {};
  window.$zoho.salesiq = window.$zoho.salesiq || {
    widgetcode: SALESIQ_WIDGET_CODE,
    values: {},
    ready: () => {
      // Our own chat button opens the window; keep Zoho's floating button hidden.
      window.$zoho.salesiq.floatbutton.visible('hide');
      if (window.__ademeroOpenChatOnReady) {
        window.__ademeroOpenChatOnReady = false;
        openSalesIQWindow();
      }
    },
  };
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'zsiqscript';
  script.defer = true;
  script.src = `https://salesiq.zohopublic.com/widget?wc=${SALESIQ_WIDGET_CODE}`;
  document.head.appendChild(script);
};
